import { inject } from '@angular/core';
import { map, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { selectOrganizer } from '@deltager/organizers/admin/redux/root.state';
import { TypedPathRoute } from '@deltager/organizers/admin/core/app-routing/app-routing.module';

const reportingTabs = ['transactions', 'settlements', 'transfers', 'trial-sessions'] as const;
export type ReportingTabs = typeof reportingTabs[number] | '';

export const REPORTING_CHILDREN_ROUTES: TypedPathRoute<ReportingTabs[]> = [
  {
    path: 'transactions',
    loadComponent: () =>
      import('@deltager/organizers/admin/modules/reporting/reporting-main/transactions/transactions.component').then(
        m => m.TransactionsComponent,
      ),
  },
  {
    path: 'settlements',
    loadComponent: () =>
      import('@deltager/organizers/admin/modules/reporting/reporting-main/settlements/settlements.component').then(
        m => m.SettlementsComponent,
      ),
  },
  {
    path: 'transfers',
    loadComponent: () =>
      import('@deltager/organizers/admin/modules/reporting/reporting-main/transfers/transfers.component').then(
        m => m.TransfersComponent,
      ),
    canActivate: [
      () =>
        inject(Store)
          .select(selectOrganizer)
          .pipe(
            map(settings => settings.modules.enableTransferParticipant),
            take(1),
          ),
    ],
  },
  {
    path: 'trial-sessions',
    loadComponent: () =>
      import('@deltager/organizers/admin/modules/reporting/reporting-main/trial-sessions/trial-sessions.component').then(
        m => m.TrialSessionsComponent,
      ),
    canActivate: [
      () =>
        inject(Store)
          .select(selectOrganizer)
          .pipe(
            map(settings => settings.modules.enableUpgradeParticipant),
            take(1),
          ),
    ],
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'transactions',
  },
];
